import React from "react";
import { Routes } from "./routes";
import { useSelector } from "react-redux"
import Theme from "./theme/theme.module.css";

const App = () => {
  const mode = useSelector(state => state.theme.mode)
  return (
    <div className={`${Theme[mode]}`}>
      <Routes />
    </div>
  );
};

export default App;
